import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DirectionService } from '../../services/direction.service';
import { RouterModule } from '@angular/router';
import { TagModule } from 'primeng/tag';
import { IProject } from '../../interfaces';
import { StrategyService } from '../../services/strategy.service';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
const weightColors = {
  25: "#cc3300",
  20: "#ff9966",
  15: "#ffcc00",
  10: "#99cc33",
  5: "#339900",
  1: "#28a745"
}
@Component({
  selector: 'app-goal-tree',
  standalone: true,
  imports: [
    ButtonModule,
    CommonModule,
    TranslateModule,
    RouterModule,
    TagModule,
    TooltipModule,
    ProgressBarModule,
    TableModule],
  templateUrl: './goal-tree.component.html',
  styleUrl: './goal-tree.component.scss'
})
export class GoalTreeComponent {
  dir!: 'rtl' | 'ltr';
  @Input() pillars!: any[];
  @Input() selectedStrategy!: any;
  selectedProject!: IProject;
  project: any;
  isModalVisible = false;
  tabletype = 'goalsAndIndicators'

  toggleStates: { [goalId: number]: boolean } = {};

  constructor(private directionService: DirectionService, private strategyService: StrategyService) {
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    });
  }
  onToggle(goalId: number): void {
    // Toggle the state for the specific goal
    this.toggleStates[goalId] = !this.toggleStates[goalId];
    console.log(this.toggleStates[goalId]);
  }

  isToggled(goalId: number): boolean {
    // Return true if the details element is toggled open, false otherwise
    return this.toggleStates[goalId] ?? false;
  }
  showModal(project: any) {
    this.selectedProject = project;
    this.strategyService.GetProjectPerformance(this.selectedStrategy.id, project.id).subscribe((response: any) => {
      this.project = response['data'];
    })
    this.isModalVisible = true;
  }
  getWeightColor(weight: number) {
    if (weight == 1) return weightColors[1]
    if (weight > 1 && weight <= 5) return weightColors[5]
    if (weight > 5 && weight <= 10) return weightColors[10]
    if (weight > 10 && weight <= 15) return weightColors[15]
    if (weight > 15 && weight <= 20) return weightColors[20]
    if (weight > 20 && weight <= 25) return weightColors[25]
    return ''
  }
  closeModal() {
    this.tabletype = 'goalsAndIndicators'
    this.isModalVisible = false;
  }

  tableType(tableType: string) {
    this.tabletype = tableType;
  }
}
